import React, {useMemo} from 'react';

import {Box} from '../../../components/core/view';
import {Components} from '@buncha/localization/types';
import {H5Text} from '../../../components/core/text';
import {Modules} from '@buncha/utils/types';
import {StyleSheet} from 'react-native';
import font from '../../../appStyles/style/font';
import {getWidth} from '../../../utils/common';
import {useColorThemeType} from '../../../appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  quantity: number;
  hasTotalQunatity?: boolean;
  isNSCItem?: boolean;
  totalWeight?: number;
  unit?: string;
}

function ItemQuantityPill(props: Props) {
  const theme = useColorThemeType('main');
  const {body} = useGetLocale(Modules.components, Components.components) ?? {};

  const getText = useMemo(() => {
    if (props?.isNSCItem && props?.totalWeight && props?.unit)
      return body?.weight
        ?.replace(
          '{totalWeight}',
          props.totalWeight?.toFixed(2).replace(/[.,]00$/, ''),
        )
        ?.replace('{units}', props.unit);
    if (props?.hasTotalQunatity)
      return body?.totalQuantity?.replace('{totalQuantity}', props.quantity);
    return body?.quantity?.replace('{quantity}', props.quantity);
  }, [
    body?.quantity,
    body?.totalQuantity,
    body?.weight,
    props?.hasTotalQunatity,
    props?.isNSCItem,
    props.quantity,
    props.totalWeight,
    props.unit,
  ]);

  return (
    <Box
      style={[
        styles.ParentContainer,
        {backgroundColor: theme?.background?.yellow[300]},
      ]}>
      <H5Text style={[styles.typo, {color: theme?.text?.blue[300]}]}>
        {getText}
      </H5Text>
    </Box>
  );
}

export default React.memo(ItemQuantityPill);

const styles = StyleSheet.create({
  ParentContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    height: 27,
    minWidth: getWidth(56),
    borderRadius: 50,
    paddingHorizontal: 10,
  },
  typo: {
    ...font.FontSize.fontP10,
    fontFamily: font.fonts.muliBold,
  },
});
